import React, { forwardRef, useCallback, useId, useState } from 'react';

import { TextField, TextFieldProps } from '@mui/material';

/**
 * Text field tuned to suppress Chrome's saved-address / email autofill dropdown.
 * Chrome ignores autocomplete="off" on email-like inputs; combine an unrecognized
 * autocomplete token, a non-email name/id, and readonly-until-focus instead.
 */
export const CONTACT_EMAIL_LOOKUP_AUTOCOMPLETE = 'one-time-code';

export const ContactEmailLookupTextField = forwardRef<
  HTMLDivElement,
  TextFieldProps
>(function ContactEmailLookupTextField(
  { onFocus, inputProps, sx, ...props },
  ref
) {
  const inputId = useId();
  const autofillSafeName = `liscio-contact-lookup-${inputId.replace(/:/g, '')}`;
  const [blockBrowserAutofill, setBlockBrowserAutofill] = useState(true);

  const handleFocus = useCallback(
    (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setBlockBrowserAutofill(false);
      onFocus?.(event);
    },
    [onFocus]
  );

  return (
    <TextField
      {...props}
      ref={ref}
      type="text"
      autoComplete={CONTACT_EMAIL_LOOKUP_AUTOCOMPLETE}
      onFocus={handleFocus}
      sx={{
        '& input[readonly]': {
          backgroundColor: 'background.paper',
          cursor: 'text',
        },
        ...sx,
      }}
      inputProps={{
        ...inputProps,
        id: autofillSafeName,
        inputMode: 'email',
        name: autofillSafeName,
        autoComplete: CONTACT_EMAIL_LOOKUP_AUTOCOMPLETE,
        readOnly: blockBrowserAutofill,
      }}
    />
  );
});
